import React from "react";
import {
  Box,
  Flex,
  Text,
  Badge,
  Grid,
  GridItem,
  Divider,
} from "@chakra-ui/react";
import { Truck } from "lucide-react";
import InfoCard from "components/Card/InfoCard";
import getStatusColor from "../utils/StatusColor";

const ViewDelivery = ({ delivery: deliveryData }) => {
  if (!deliveryData) {
    return (
      <Flex align="center" justify="center" h="100%">
        <Text>No delivery data available.</Text>
      </Flex>
    );
  }

  return (
    <Flex direction="column" p={8} width="100%">
      <InfoCard
        heading="Delivery Information"
        icon={<Truck />}
        headingFontSize="md"
        headingFontWeight="500"
        headingColor="gray.500"
      >
        <Box mt={4}>
          <Grid
            templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }}
            gap={6}
            mb={6}
          >
            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Tracking Number
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.trackingNumber}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Driver Name
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.driver}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Status
              </Text>
              <Badge colorScheme={getStatusColor(deliveryData.status)}>
                {deliveryData.status}
              </Badge>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Sender Name
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.sender}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Recipient Name
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.recipient}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Pickup Time
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.pickupTime}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Dropoff Time
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.dropoffTime}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Created At
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.createdAt}
              </Text>
            </GridItem>

            <GridItem>
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Updated At
              </Text>
              <Text fontSize="sm" color="gray.500">
                {deliveryData.updatedAt}
              </Text>
            </GridItem>
          </Grid>

          <Divider />
        </Box>
      </InfoCard>
    </Flex>
  );
};

export default ViewDelivery;
